export default "__VITE_ASSET__DNfOhqXi__"